module Meevo.Plugins.MerchantAccounts {
    "use strict";

    export class SurchargesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MerchantAccountSurcharges> {            
        customAuditCriteria = {
            nounId: Model.NounEnum.MerchantAccountSurcharges,
        };
      
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected $translate?: angular.translate.ITranslateService,
            roundingService?: Components.Common.IRoundingService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;

            this.dataService.getSettings(Model.BusinessSettingCategoryEnum.Register, null)
                .then((settings: Model.RegisterSettings) => {
                    this.maxMerchantAccountSurchargePercent = settings.maxMerchantAccountSurchargePercent;
                    this.maxMerchantAccountSurchargeAmount = roundingService.divideNormalizedNumbers(this.maxMerchantAccountSurchargePercent, 100);
                });

            this.refreshOtherPaymentTypeCriteria();
        }

        maxMerchantAccountSurchargeAmount: number;
        maxMerchantAccountSurchargePercent: number;
        otherPaymentTypeCriteria;
        otherPaymentType: Model.PaymentType = undefined;

        get cardSurcharges() {
            return this.model ? this.model.surcharges.filter(surcharge => surcharge.paymentCategory === Model.PaymentCategoryEnum.CreditDebit) : [];
        }

        get otherSurcharges() {
            return this.model ? this.model.surcharges.filter(surcharge => surcharge.paymentCategory !== Model.PaymentCategoryEnum.CreditDebit) : [];
        }

        refreshOtherPaymentTypeCriteria() {
            this.otherPaymentTypeCriteria = {
                includeInactive: false,
                includeDeleted: false,
                paymentCategory: Model.PaymentCategoryEnum.Other,
                excludeIdList: this.otherSurcharges.filter(otherSurcharge => otherSurcharge.isEnabled).map(otherSurcharge => otherSurcharge.paymentTypeId)
            };
        }

        otherPaymentTypeSelected(): void {
            const matchedSurcharge = this.model.surcharges.find(surcharge => surcharge.paymentTypeId === this.otherPaymentType.id);
            if (matchedSurcharge) {
                matchedSurcharge.isEnabled = true;
            } else {
                this.model.surcharges.push(this.createSurcharge(this.otherPaymentType));
            }

            this.otherPaymentType = null;
            this.refreshOtherPaymentTypeCriteria();
        }

        createSurcharge(otherPaymentType: Model.PaymentType): Model.MerchantAccountSurcharge {
            return {
                paymentTypeId: otherPaymentType.id,
                paymentCategory: otherPaymentType.paymentCategoryEnum,
                paymentTypeDisplayName: otherPaymentType.displayName,
                amount: 0,
                isEnabled: true
            }
        }

        deleteOtherSurcharge(otherSurcharge: Model.MerchantAccountSurcharge): void {
            otherSurcharge.isEnabled = false;
            this.refreshOtherPaymentTypeCriteria();
        }

        public enableSurchargesToggled() {
            if (!this.model.isSurchargeEnabled) {
                return;
            }

            const message = this.$translate.instant('MESSAGE_SURCHARGE_ENABLE');
            const options = { okButtonContentKey: 'LABEL_YES', cancelButtonContentKey: 'LABEL_NO', showCancelButton: true };
            this.modalService.warning(message, Components.Modal.ModalTranslationModes.AsHtml, false, options)
                .then(res => this.dataService.trackUsage(Model.NounEnum.MerchantAccountSurcharges, Model.VerbEnum.Accepted, null, this.model.merchantAccountId, this.$translate.instant('SURCHARGE_DISCLAIMER_ACCEPTED')))
                .catch(res => this.model.isSurchargeEnabled = false);
        }

        public sectionModelRetrieved(): void {
            this.refreshOtherPaymentTypeCriteria();
        }

        public isSurchargeAmountInvalid(surcharge) {
            return surcharge.isEnabled && surcharge.amount > this.maxMerchantAccountSurchargeAmount;
        }
    }
}